export const setVideoAvailableVariant = variant => ({
    type: 'SET_VIDEO_AVAILABLE_VARIANT',
    variant
});

